<template>
    <div class="flex justify-center">
        {{ maxWaitTime }}
    </div>
</template>
<script>
import get from 'lodash/get'
import { getInitialTime } from '@/util/timeUtils'
import { getMinValue } from '@/helpers/util'
import Timer from '@/util/Timer'
import { ALL_QUEUE_ID, QUEUE_RULE_NO_RULE } from '@/enum/redesignQueueDashboardStatistics'

export default {
    props: {
        queueID: {
            type: [ Number, String ],
            default: null
        },
        queueRuleID: {
            type: [ Number, String ],
            default: null
        },
        queueName: {
            type: String
        }
    },
    data () {
        return {
            timeout: null,
            timer: new Timer(),
        }
    },
    computed: {
        getQueueByID () {
            return this.$store.getters['queues/filterQueuesByIds']([ this.queueID ])
        },
        allQueueCalls () {
            return this.$store.getters['queues/allQueueCalls']
        },
        maxWaitTime () {
            return this.timer.displayTime
        },
        queueCalls () {
            if (this.queueID === ALL_QUEUE_ID) {
                return this.allQueueCalls
            }

            const queueCalls = get(this.getQueueByID, '[0].Calls', [])

            if (this.queueRuleID === QUEUE_RULE_NO_RULE) {
                return queueCalls.filter(call => !call.queueRule)
            } else if (this.queueRuleID !== null) {
                return queueCalls.filter(call => Number(call.queueRule) === Number(this.queueRuleID))
            } else {
                return queueCalls
            }
        }
    },
    methods: {
        getStats () {
            const calls = this.queueCalls

            let minJoinTimestamp = new Date().getTime() * 10000

            if (calls.length) {
                minJoinTimestamp = getMinValue(calls, 'JoinTimeStamp_UTC_CLIENT')
            }
            minJoinTimestamp = getInitialTime(minJoinTimestamp)

            return {
                minJoinTimestamp,
                calls
            }
        },
        setCounterState (calls) {
            const stats = this.getStats()
            this.timer.stop()
            this.timer.setValue(stats.minJoinTimestamp)
            if (calls.length !== 0) {
                this.timer.start()
            }
        }
    },
    watch: {
        queueCalls: {
            deep: true,
            immediate: true,
            handler (calls) {
                this.setCounterState(calls)
            }
        },
        maxWaitTime: {
            immediate: true,
            handler (val) {
                if (this.queueID !== ALL_QUEUE_ID) {
                    this.$emit('getMaxWaitTime', {
                        value: val,
                        queueID: this.queueID,
                        queueName: this.queueName
                    })
                }
            }
        }
    },
    beforeUnmount () {
        this.timer.destroy()
    },
}
</script>
